/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NationalityInputs */

const en__field_nationality = /** @type {(inputs: _Field_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationality`)
};

const de__field_nationality = /** @type {(inputs: _Field_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationalität`)
};

/**
* | output |
* | --- |
* | "Nationality" |
*
* @param {_Field_NationalityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_nationality = /** @type {((inputs?: _Field_NationalityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NationalityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_nationality(inputs)
	return de__field_nationality(inputs)
});